import { deleteData, getData, postData, putData } from "./APIServiceInterface";

export const getCurrencyService = async () => {
  const response = await getData("/currency/get");
  return response;
};

export const createNewCurrencyService = async (payload) => {
  const response = await putData("/currency/create", payload);
  return response;
};

export const updateCurrencyService = async (id, payload) => {
  return await postData(`/currency/update?currencyId=${id}`, payload);
};

export const deleteCurrencyService = async (payload) => {
  return await deleteData(`/currency/delete?currencyId=${payload}`);
};

